import {
  AnonymousErrorCodes,
  CommonErrorCodesLookup,
  extendErrorLookup,
} from '~/common/helpers';
import { AnyTranslationKeys } from '~/common/types';

type AnonymousOnlyKeys = Exclude<
  keyof typeof AnonymousErrorCodes,
  keyof typeof CommonErrorCodesLookup
>;

export const AnonymousErrorCodesLookup = extendErrorLookup<
  keyof typeof CommonErrorCodesLookup,
  AnonymousOnlyKeys
>(CommonErrorCodesLookup, {
  [AnonymousErrorCodes.ERR_INVALID_PASSWORD]:
    'app.errors.onboarding.invalid_password',
  [AnonymousErrorCodes.ERR_REGISTRATION_CUSTOMER_NOT_FOUND]:
    'app.errors.err_registration_customer_not_found',
  [AnonymousErrorCodes.ERR_REGISTRATION_MANAGER_EXISTS]:
    'app.errors.err_registration_manager_exists',
  [AnonymousErrorCodes.ERR_USER_ALREADY_ONBOARDED]:
    'app.errors.onboarding.user_already_onboarded',
  [AnonymousErrorCodes.ERR_USER_NOT_FOUND]:
    'app.errors.onboarding.user_not_found',
  [AnonymousErrorCodes.ERR_USER_INVALID_TOKEN]:
    'app.errors.onboarding.invalid_token',
  [AnonymousErrorCodes.ERR_UNIQUE_USER]: 'app.errors.onboarding.email_exists',
} as Record<AnonymousOnlyKeys, AnyTranslationKeys>);
